import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchReportData = args => {
    const { reports, season, gameType } = args;

    const selectedReports = reports.selectedReports.map(report => report.reportType).toString();

    const teams = reports.selectedTeams.map(team => team.id).toString();

    return doDefaultFetch(
        `/site/api/game/reports` +
        `?season=${season.value}` +
        `&gameType=${gameType.value}` +
        `&report=${selectedReports}` +
        `&includedTeams=${teams}`,
        args
    );
};

export default {
    fetchReportData
};
